import * as React from 'react';
import ForwardArrowIcon from 'assets/forward-arrow.inline.svg';
import classnames from 'classnames';
import InputBase, { InputBaseProps } from '../InputBase/InputBase';
import * as styles from './InputWithCta.module.scss';

export interface InputWithCtaProps extends InputBaseProps {
    classes?: {
        root?: string;
    };
}

function InputWithCta({ classes, ...props }: InputWithCtaProps) {
    return (
        <div className={styles.inputContainer}>
            {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
            <label className="sr-only" htmlFor={props.id}>
                {props.placeholder}
            </label>
            <InputBase
                className={classnames(classes?.root, styles.inputWithCta)}
                {...props}
            />
            <button className={styles.submitButton} type="submit">
                <span className="sr-only">Submit</span>
                <ForwardArrowIcon />
            </button>
        </div>
    );
}

export default InputWithCta;
